module.exports = __webpack_public_path__ + "static/media/si_1.0ce30487.JPG";